angular.module('picmonicng').factory('PQService', [
  'tlQuestionsResource',
  '$timeout',
  '$document',
  'User',
  '$q',
  'UserService',
  'SplitTestService',
  function (tlQuestionsResource, $timeout, $document, User, $q, UserService, SplitTestService) {
    return {
      loading: false,
      numberOfFreeQuestions: 5,
      question: null,
      complete: false,
      upgradeVisible: true,
      promise: null,
      has_access: false,
      stats: {},
      picmonicMarkets: [101, 202, 100, 203, 115, 116, 109, 122, 117],
      loadQuestion: function (questionId) {
        var self = this;

        if (self.loading) {
          return;
        }

        self.loading = true;

        if (UserService.user.user_id) {
          self.has_access = UserService.user.active_markets.filter(m => m.market_id === 502).length > 0;
          self.has_tl_access =
            UserService.user.active_markets.filter(m => m.market_id >= 503 && m.market_id <= 511).length > 0;
        } else {
          self.has_access = false;
        }

        const stats = self.loadStats();
        const question = questionId ? tlQuestionsResource.get({ question_id: questionId }) : tlQuestionsResource.get();

        stats.then(function (data) {
          if (data.total === data.completed) {
            self.complete = true;
          }
          self.upgradeVisible = self.has_access
            ? false
            : data.completed >= self.numberOfFreeQuestions || self.has_tl_access;
        });

        let firstLoad = false;

        if (!self.question) {
          firstLoad = true;
        }

        question.$promise
          .then(function (result) {
            self.question = result;
          })
          .finally(function () {
            $timeout(function () {
              self.loading = false;

              var homePracticeQuestions = angular.element(document.getElementById('home-practice-questions-container'));

              if (homePracticeQuestions.length && !firstLoad) {
                $document.scrollToElement(homePracticeQuestions, 16, 1000);
              }
            });
          });

        self.promise = $q.all([question.$promise, stats.$promise]);

        return self.promise;
      },
      loadStats: function () {
        var self = this;

        let stats = User.getv3({
          resource: 'practice_questions',
        });

        stats.$promise.then(function (data) {
          self.stats = data;
          if (!self.has_access) {
            self.stats.total = self.getStatsTotal();
          }
        });

        return stats.$promise;
      },
      canSeePracticeQuestions: function () {
        var self = this;

        hasPurchased =
          UserService.user &&
          UserService.user.active_markets &&
          UserService.user.active_markets.filter(m => m.market_id === 502).length > 0;
        inMarket = UserService.user && UserService.user.lead && self.picmonicMarkets.includes(UserService.user.lead);

        return hasPurchased || inMarket;
      },
      getStatsTotal: function () {
        switch (UserService.user.lead) {
          case 101:
          case 202:
            return 900;
          case 100:
            return 2613;
          case 203:
            return 1878;
          case 115:
            return 1311;
          case 116:
            return 1396;
          case 109:
            return 1564;
          case 122:
            return 1014;
          case 117:
            return 910;
          default:
            return 900;
        }
      },
    };
  },
]);
